import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { HeadingLevel } from "@/core/types/types";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";
import Icon from "@/core/components/Icon/Icon";

interface AccordionSection {
  title: string;
  subsections: Array<string>;
}

interface AccordionSubsectionProps {
  item: string;
  itemIndex: number;
}

const CompensationInfoAccordionSubsection = ({
  item,
  itemIndex,
}: AccordionSubsectionProps) => {
  return (
    <Box mt={itemIndex === 0 ? 0 : 2} key={item}>
      <Box display="flex" alignItems="center">
        <Box mr="18px" display="flex" alignItems="center">
          <Icon
            src={`images/icons/compensation-info/${item}.svg`}
            alt="compensation-icon"
          />
        </Box>
        <Typography>{t(`compensationInfo.${item}.description`)}</Typography>
      </Box>
    </Box>
  );
};

const CompensationInfoAccordion = () => {
  const compensationInfoProps: Array<AccordionSection> = [
    {
      title: t("compensationInfo.compensated"),
      subsections: ["cash", "coupon", "travel"],
    },
    {
      title: t("compensationInfo.notCompensated"),
      subsections: ["plate", "house", "ticket"],
    },
  ];

  return (
    <>
      {compensationInfoProps.map(
        (section: AccordionSection, sectionIndex: number) => {
          return (
            <Box mt={sectionIndex === 0 ? 0 : 4} key={sectionIndex}>
              <Box mb={2}>
                <Typography variant={HeadingLevel.H3}>
                  {section.title}
                </Typography>
              </Box>
              {section.subsections.map((item: string, itemIndex: number) => {
                return (
                  <CompensationInfoAccordionSubsection
                    key={item}
                    item={item}
                    itemIndex={itemIndex}
                  />
                );
              })}
            </Box>
          );
        }
      )}
    </>
  );
};

export default CompensationInfoAccordion;
